import { useEffect, useState } from "react"
import { Button, ListItemButton } from "@mui/material"
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

export default function OrderCategories(props) {
    const [orderCategories, setOrderCategories] = useState(false)
    const [newCategories, setNewCategories] = useState([])

    useEffect(() => {
        setNewCategories(props.categories)
    }, [props.categories])

    const changeCategoryPosition = (value, categoryIndex) => {

        if (0 <= categoryIndex + value && categoryIndex + value < newCategories.length) {

            let aux = [...newCategories]
            aux[categoryIndex] = newCategories[categoryIndex + value]
            aux[categoryIndex + value] = newCategories[categoryIndex]

            setNewCategories(aux)
        }
    }

    const saveChanges = () => {
        props.orderCategories(newCategories)
        setOrderCategories(false)
    }

    return (
        <>
            <Button
                variant="outlined"
                onClick={setOrderCategories.bind(this, !orderCategories)}
                fullWidth
            >
                Cambiar orden de las categorias
            </Button>

            <Dialog
                open={orderCategories}
                onClose={setOrderCategories.bind(this, false)}
                fullScreen
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={setOrderCategories.bind(this, false)}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Ordenar categorias
                        </Typography>
                        <Button autoFocus color="success" variant="contained" onClick={saveChanges.bind(this)}>
                            Guardar cambios
                        </Button>
                    </Toolbar>
                </AppBar>

                <DialogContent>

                    <List>
                        {newCategories.map((category, index) => {
                            return (
                                <div key={category}>
                                    <ListItem
                                        sx={{ transition: 'all 0.3s ease-out' }}
                                    >
                                        <Typography
                                            variant="h5"
                                        >
                                            {(index + 1)}
                                        </Typography>

                                        <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />

                                        <ListItemText
                                            primary={category}
                                            secondary={"Productos: " + props.filterProducts(category).length}
                                        />

                                        <Stack
                                            direction="row"
                                        >
                                            <ListItemButton
                                                onClick={() => changeCategoryPosition(-1, index)}
                                                sx={{ justifyContent: 'center' }}
                                            >
                                                <KeyboardDoubleArrowUpIcon />
                                            </ListItemButton>
                                            <ListItemButton
                                                onClick={() => changeCategoryPosition(1, index)}
                                                sx={{ justifyContent: 'center' }}
                                            >
                                                <KeyboardDoubleArrowDownIcon />
                                            </ListItemButton>
                                        </Stack>

                                    </ListItem>
                                    <Divider />
                                </div>
                            )
                        })}

                    </List>
                </DialogContent>
            </Dialog>
        </>
    )
}